import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@/shared/icons';

/**
 * 403 — anatomia EXATA do mockup error-pages.html:
 * card 420px centrado (brand 44 roxo + eico 64 vermelho c/ escudo + título 19 +
 * descs 13.5/12.5 + botão home full 42px roxo). Fora do ThemeProvider — literais LIGHT do DS (vars --theme-* não existem aqui).
 *
 * `embedded`: versão dentro do layout logado (trava de rotas — `RouteAccessGuard`).
 * Ocupa só a área de conteúdo e deixa o fundo da página aparecer, então o menu
 * lateral continua ali para a pessoa seguir para o que pode abrir. O cartão
 * segue claro, como as modais.
 */
interface UnauthorizedProps {
  embedded?: boolean;
}

export const Unauthorized: React.FC<UnauthorizedProps> = ({ embedded = false }) => {
  return (
    <div
      className={embedded ? 'h-full flex items-center justify-center p-6' : 'min-h-screen flex items-center justify-center p-6'}
      style={{
        backgroundColor: embedded ? 'transparent' : '#f8fafc',
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
      data-testid={embedded ? 'unauthorized-embedded' : 'unauthorized-page'}
    >
      <div
        className="w-full max-w-[420px] rounded-2xl text-center"
        style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(0, 0, 0, 0.06)',
          padding: '36px 32px',
        }}
        data-testid="unauthorized-card"
      >
        {/* `.brand` */}
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center mx-auto text-white font-extrabold text-lg"
          style={{ backgroundColor: '#8b5cf6', marginBottom: 22 }}
        >
          T
        </div>
        {/* `.eico.red` */}
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto"
          style={{ backgroundColor: 'rgba(239, 68, 68, 0.10)', color: '#ef4444', marginBottom: 18 }}
        >
          <Icon name="shield" className="w-7 h-7" />
        </div>
        <h1
          className="font-bold"
          style={{ fontSize: 19, letterSpacing: '-0.02em', margin: '6px 0 12px', color: '#1e293b' }}
        >
          Acesso Negado
        </h1>
        <p style={{ fontSize: 13.5, color: '#6b7280', margin: '0 0 6px', lineHeight: 1.6 }}>
          Você não tem permissão para acessar esta página.
        </p>
        <p style={{ fontSize: 12.5, color: '#94a3b8', margin: 0, lineHeight: 1.6 }}>
          Entre em contato com o administrador da conta se acredita que isso é um engano.
        </p>
        {/* `.home` */}
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 w-full rounded-xl text-white font-semibold text-sm transition-colors"
          style={{ height: 42, marginTop: 22, backgroundColor: '#8b5cf6' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#7c3aed'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#8b5cf6'; }}
          data-testid="unauthorized-home"
        >
          <Icon name="home" className="w-4 h-4" />
          Voltar ao Dashboard
        </Link>
      </div>
    </div>
  );
};
